import { Container } from 'react-bootstrap';
import logo from '../components/Nav/assets/Sidebar_Logo_Open.png';

const TermsAndConditions = ({ data }) => {
  return (
    <Container fluid>
      <div className="d-flex justify-content-center justify-content-md-start">
        <img className="w-75 w-md-25" src={logo} />
      </div>
      <div className="d-flex flex-column justify-content-center text-center align-items-center mb-2 p-2 h-lg h-lg-xl">
        <h1>Terms of Use</h1>
        <p>This Terms of Use Policy was last modified on {data.date}</p>
        <a href="/" className="text-white">
          Return to home
        </a>
        <div
          className="overflow-auto text-start d-flex mt-4 p-3 flex-column bg-primary-shadow customScrollbar-Y"
          style={{ whiteSpace: 'pre-wrap' }}
        >
          <div className="html-content" dangerouslySetInnerHTML={{ __html: data.page }} />
        </div>
      </div>
    </Container>
  );
};

export default TermsAndConditions;
